import { BaleTypeEnum, QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { BaleInfo } from "./bale-info.entity";

@Entity('bale_items')
export class BaleItems {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    // @Column('int',{
    //     name:'bale_id',
    //     nullable:false
    // })
    // baleId : number

    @Column('int',{
        name:'agent_id',
        nullable:false
    })
    agentId : number

    @Column('enum',{
        name:'quality',
        nullable:false,
        enum:QualityTypeEnum
    })
    quality : QualityTypeEnum

    @Column('decimal',{
        name:'quantity',
        precision:10,scale:3,
        nullable:false
    })
    quantity : number

    @Column('varchar',{
        name:'voucher_no',
        length:30,
        nullable:false
    })
    voucherNo: string

    @Column('int',{
        name:'inward_item_id',
        nullable:false
    })
    inwardItemId : number

    @Column('decimal',{
        name:'work_order_qty',
        precision:10,scale:3,
        nullable:false
    })
    workOrderQty : number

    @Column('int',{
        name:'plant_id',
        nullable:false
    })
    plantId : number

    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId : number

    @ManyToOne(type => BaleInfo, bale => bale.baleItemsInfo, { nullable: false, })
    @JoinColumn({ name: "bale_id" })
    baleInfo: BaleInfo;


}